module.exports = __webpack_public_path__ + "media/browser/firefox-03b1d3c2.svg";